import { render, staticRenderFns } from "./VerifyUserIdentity.vue?vue&type=template&id=0e482d78"
import script from "./VerifyUserIdentity.vue?vue&type=script&lang=js"
export * from "./VerifyUserIdentity.vue?vue&type=script&lang=js"
import style0 from "./VerifyUserIdentity.vue?vue&type=style&index=0&id=0e482d78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports